import React from "react";
import InputFactory from "../../../../components/InputFactory";
import { dialog } from "../../../../nq-component";
import { object } from "framer-motion/m";

function DialogCreate({ schema, objects, onChangeData, handleSubmit }) {
  function handleChange(value, field) {
    onChangeData(value, field);
  }

  return (
    <>
      <div
        className="  p-4 rounded"
        style={{ maxWidth: "450px", margin: "auto" }}
      >
        <div
          className="d-flex align-items-center mb-3"
          style={{ color: "#d18237" }}
        >
          <div className="bg-light p-3 rounded-circle">
            <i className="bi bi-person  fs-4"></i>
          </div>
          <h5 className="fw-bold ms-2">Create New User</h5>
        </div>

        <div className="mb-3">
          <label className="form-label fw-bold">Select Employee</label>
          <InputFactory
            type="Pointer"
            target="employees"
            field="employee"
            schemas={schema}
            onChange={(value, field) => handleChange(value, field)}
            placeholder="Enter username"
            required
            defaultValue={objects?.employee}
          />
        </div>

        <div className="mb-3">
          <label className="form-label fw-bold">Username</label>
          <InputFactory
            type="String"
            field="username"
            onChange={(value, field) => handleChange(value, field)}
            placeholder="Enter username"
            defaultValue={objects?.username}
          />
        </div>

        <div className="mb-4">
          <label className="form-label fw-bold">Password</label>
          <InputFactory
            type="Password"
            field="password"
            transform="md5"
            onChange={(value, field) => handleChange(value, field)}
            placeholder="Enter username"
          />
        </div>

        <div className="mb-4">
          <label className="form-label fw-bold">Roles</label>
          <InputFactory
            type="Pointer"
            target="roles"
            schemas={schema}
            field="roles"
            onChange={(value, field) => handleChange(value, field)}
            placeholder="Enter username"
            defaultValue={objects?.roles?.[0] || undefined}
          />
        </div>

        <div className="d-flex justify-content-center">
          <button
            className="btn text-white px-4 me-2"
            style={{ backgroundColor: "#d18237" }}
            onClick={() => handleSubmit()}
          >
            {objects?.id ? "Update" : "Confirm"}
          </button>
          <button
            className="btn px-4"
            onClick={() => dialog.close()}
            style={{ backgroundColor: "#d0d0d0" }}
          >
            Cancel
          </button>
        </div>
      </div>
    </>
  );
}

export default DialogCreate;
